import { ComponentClassNames } from '../../util/classNames';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

type MaxZoomClassNames = ComponentClassNames<'zoomContainer'>;

export const getClassNames = memoizeFunction(
  (maxZoom, className): MaxZoomClassNames =>
    mergeStyleSets({
      zoomContainer: [
        {
          width: `${100 / maxZoom}%`,
          height: `${100 / maxZoom}%`,
          transform: `scale(${maxZoom})`,
        },
        className,
      ],
    })
);
